import React from "react"
import YouTube from "react-youtube"

export default function YoutubePlayer({ ...props }) {
  const videoId = props.videoid ?? props.videoId;
  return (
    <YouTube
      videoId={videoId}
      opts={{
        width: "100%"
      }}
      {...props}
    />
  )
}
